var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-portlet',{attrs:{"title":"Artworks","icon":"la la-camera-retro"}},[_c('artwork-list',{attrs:{"allow-editing":"","show-names":""},model:{value:(_vm.selected_artwork),callback:function ($$v) {_vm.selected_artwork=$$v},expression:"selected_artwork"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }